/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Modification within the input data. These modifications lead to different prices.
 */
export interface Modification {
  /**
   * What kind of modification was done.   Examples: Examples are: PACKAGE_MODIFIED, INCENTIVE_CODE_REMOVED, ...
   */
  modificationKind?: string;
  /**
   * Depending on the modification kind, this may give additional information. For example: In case of PACKAGE_MODIFIED this contains the modified package like BASIC, CLASSIC, PREMIUM.
   */
  value?: any | null;
}
